import { http } from '@/plugins/http'
import Integration from '@/types/Integration'
import PaginatedResponse from '@/types/PaginatedResponse'
import { AxiosResponse } from 'axios'

export default class IntegrationService {
  async index(): Promise<AxiosResponse<PaginatedResponse<Integration>>> {
    return await http.get<PaginatedResponse<Integration>>(`/api/v1/office/integrations`)
  }
}
